import {Component} from '@angular/core';
import {ButtonComponent} from 'src/app/ui/shared/component/button/button.component';

@Component({
  selector: 'app-premium-button',
  template: `
    <app-button
      bgColor="premium"
      bgHover="premium"
      textColor="black"
      textColorHover="black"
    >
      <ng-content></ng-content>
    </app-button>
  `,
})

export class PremiumButtonComponent extends ButtonComponent {
}
